export default "__VITE_ASSET__B5RD3e_3__"